export const MAX_POIDS_PAR_COLIS = 25;

export interface LigneWithPoids {
  poids?: number | null;
  corbeille?: number | null;
}

/**
 * Somme des poids des lignes non en rupture (corbeille !== 1).
 */
export function getTotalPoidsNonRupture(
  lignes: LigneWithPoids[] | undefined | null,
): number {
  if (!lignes || !Array.isArray(lignes)) return 0;
  return lignes
    .filter((l) => Number(l.corbeille) !== 1)
    .reduce((sum, l) => sum + (Number(l.poids) || 0), 0);
}

/**
 * Répartit un poids total sur nbColis colis, max 25 kg par colis.
 * Remplit toujours le premier colis au maximum, puis le suivant, etc.
 * Les derniers colis restent à 0 si le total tient dans moins de nbColis.
 */
export function distributePoidsColis(
  totalPoids: number,
  nbColis: number,
  maxPoidsParColis: number = MAX_POIDS_PAR_COLIS,
): number[] {
  const n = Math.max(1, nbColis);
  const result = new Array<number>(n).fill(0);
  let remaining = Math.max(0, totalPoids);
  for (let i = 0; i < n && remaining > 0; i++) {
    const value = Math.min(maxPoidsParColis, remaining);
    result[i] = Math.round(value * 1000) / 1000;
    remaining -= value;
  }
  return result;
}

export function getColisPoidsValidationMessage(
  colisPoids: number[],
): string | null {
  if (colisPoids.length === 0) {
    return "Veuillez renseigner un poids valide pour chaque colis.";
  }
  for (const poids of colisPoids) {
    const p = poids ?? 0;
    if (p > MAX_POIDS_PAR_COLIS) {
      return "Le colis ne doit pas dépasser 25 kg.";
    }
    if (p <= 0) {
      return "Veuillez renseigner un poids valide pour chaque colis.";
    }
  }
  return null;
}
